import React, { forwardRef } from 'react';
import { cn } from './cn';

const SIZES = {
  sm: 'h-7 text-caption px-2',
  md: 'h-8 text-body-sm px-3',
  lg: 'h-10 text-body px-3.5',
};

const baseField =
  'w-full bg-surface text-fg placeholder:text-fg-subtle ' +
  'border rounded-md ' +
  'transition-[border-color,box-shadow] duration-150 ease-out-soft ' +
  'focus-visible:outline-none focus-visible:border-brand-500 focus-visible:shadow-focus-ring ' +
  'disabled:cursor-not-allowed disabled:bg-ink-50 dark:disabled:bg-ink-800 disabled:text-fg-subtle';

const errorField =
  'border-danger-500 focus-visible:border-danger-500 focus-visible:shadow-focus-ring-danger';

/**
 * Input — single-line text field with optional leading/trailing adornment.
 *   size: sm | md (default) | lg
 *   invalid: adds danger styling (pair with <Field error="..."/>)
 *   leading / trailing: inline adornments (icons, prefixes, short buttons)
 */
export const Input = forwardRef(function Input(
  { size = 'md', invalid, leading, trailing, className, containerClassName, ...rest },
  ref,
) {
  if (!leading && !trailing) {
    return (
      <input
        ref={ref}
        className={cn(baseField, SIZES[size], invalid ? errorField : 'border-line', className)}
        {...rest}
      />
    );
  }
  return (
    <div className={cn('relative', containerClassName)}>
      {leading && (
        <span className="pointer-events-none absolute inset-y-0 left-0 inline-flex items-center pl-2.5 text-fg-subtle">
          {leading}
        </span>
      )}
      <input
        ref={ref}
        className={cn(
          baseField,
          SIZES[size],
          invalid ? errorField : 'border-line',
          leading && 'pl-8',
          trailing && 'pr-8',
          className,
        )}
        {...rest}
      />
      {trailing && (
        <span className="absolute inset-y-0 right-0 inline-flex items-center pr-2.5 text-fg-subtle">
          {trailing}
        </span>
      )}
    </div>
  );
});

export default Input;
